<script>
  import { beforeUpdate, afterUpdate } from "svelte";
  import Grid from "gridjs-svelte";
  import "gridjs/dist/theme/mermaid.min.css";
  import { html } from "gridjs";
  import { SvelteWrapper } from "gridjs-svelte/plugins";
  import _ from "lodash";
  import { HtmlTag, prop_dev, trusted } from "svelte/internal";
  import { onMount } from "svelte";
  import { Parser, json2csv } from "json2csv";
  import dataOrig from "./data/data.json";
  import dataUpdateDate from "./data/UpdateDate.json";
  import "./main.css";
  import "./mermaid.css";
  import { DateInput } from "date-picker-svelte";

  import TiFilter from "svelte-icons/ti/TiFilter.svelte";
  import MdFileDownload from "svelte-icons/md/MdFileDownload.svelte";

  import Header from "./UI/Header.svelte";
  import Footer from "./UI/Footer.svelte";

  //define variables for input
  let displayData;
  let buildDate = new Date(dataUpdateDate[0].currentDate);
  let day = buildDate.getDate();
  let month = buildDate.getMonth() + 1; // Months are zero-indexed, so add 1 to get the actual month number
  let year = buildDate.getFullYear();
  let Sat_name, Adm, Ntc_id, IFIC_No;

  //URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  Sat_name = urlParams.has("sat_name") ? urlParams.get("sat_name") : Sat_name;
  Adm = urlParams.has("adm") ? urlParams.get("adm") : Adm;
  //Ntc_id = urlParams.has('ntc_id') ? urlParams.get('ntc_id') : Ntc_id;
  //IFIC_No = urlParams.has('ific_no') ? urlParams.get('ific_no') : IFIC_No;

  // Pad the day and month with leading zeros if needed
  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }
  //to define the update date 
  let updateDate = `${day}.${month}.${year}`;

  afterUpdate(() => {
    console.log(`==REFRESHINPUT==`);
    searchFunction(); //everytime any input/change is made, run the searchFunction
  });

  //initializeData
  //data for original
  //let data = _.sortBy(dataOrig, (item) => {
  //  let dateComp = item.M.split(".");
 //   return item.sat_name + "_" + dateComp[2] + dateComp[1] + dateComp[0]; //set the default sorting by 1 sat_name 2 M0 date, asc    
  //});
  //data = _.reverse(data); for sort desc
  let data = _.sortBy(dataOrig, (item) => {return item.sat_name}); //set the default sorting by 1 sat_name
  //console.log(data);

  function searchFunction() {
    displayData = [...data];
    let filterValues = {
      sat_name: Sat_name,
      adm: Adm,
      //"IFIC_no": IFIC_No,
      //"ntc_id": Ntc_id
    };

    displayData = _.filter(displayData, (elem) => {
      for (let key in filterValues) {
        //console.log(key);
        if (filterValues[key] !== undefined) {
          if (!elem[key].toString().toLowerCase().includes(filterValues[key].toLowerCase())) {
            return false;
          }
        }
      }
      return true;
    });
  }

  //displayData for shown in svelte table
  displayData = [...data];

  //svelte table forming
  //for the default searching, add search={search} in the grid, however, no use in this app
  const language = {
    search: {
      placeholder: "Satellite Name",
    },
  };


  const compareDates = (a, b) => {
    const code = (x) => "" + x.split(".")[2] + x.split(".")[1] + x.split(".")[0];

    if (code(a) > code(b)) {
      return 1;
    } else if (code(b) > code(a)) {
      return -1;
    } else {
      return 0;
    }
  };

  const columns = [
    {
      id: "sat_name",
      width:'18%',
      "min-width": "14%",
      name: html("Satellite Name"),
      sort: true,
      //formatter: (cell, row) => html(`${linkSns(row)}`)
    },
    {
      id: "adm",
      //width:'8%',
      width: "6%",
      name: "ADM",
      sort: true,
    },
    {
      id: "ntwk_org",
      //width:'5%',
      width: "6%",
      name: "IGSO",
      sort: false,
    },
    {
      id: "ntc_id",
      //width:'5%',
      width: "16%",
      name: html("RES8 notice ID <br/>(link to RES8 Special Section)"),
      sort: true,
      formatter: (_, row) => {
        const url = `https://www.itu.int/net/ITU-R/space/documents/RES8/${row.cells[8].data}/${row.cells[3].data}_${row.cells[0].data}.pdf`;
        return html(`<a href="${url}">${row.cells[3].data}</a>`);
      },
    },
    {
      id: "d_rcv",
      //width:'10%',
      width: "10%",
      name: html("Date of receipt"),
      sort: { compare: compareDates },
    },
    {
    id: "submitted_with",
    width: "15%",
    name: "Submitted with",
    sort: true,
    formatter: (_, row) => {
      const value = row.cells[5].data;  
      return value ? value : "BIU/ BBIU/ RES35 prior to 01.01.2025"; 
    }
    },

    {
    id: "Attachment",
    width: "14%",
    name: html("Explanation/<br/>Technical demonstration"),
    sort: true,
    formatter: (_, row) => {
        if (row.cells[6].data === "True") { 
            const url = `https://www.itu.int/net/ITU-R/space/documents/RES8/${row.cells[8].data}/${row.cells[3].data}_${row.cells[0].data}_Attachment.pdf`;
            return html(`<a href="${url}">Attachment</a>`);
        } else {
            return "--";
        }
    },
    },

    {
      id: "Tolerance",
      //width:'5%',
      width: "15%",
      name: html("Within Tolerance/<br/>RES8 Resolves"),
      sort: true,
      formatter: (_, row) => {     
        
        let toleranceValue = row.cells[7].data ? row.cells[7].data.trim() : ''; 
        //console.log("Tolerance Value:", toleranceValue);

        let toleranceText;
        
        switch (toleranceValue) {
            case "YES":
                toleranceText = "YES";
                break;
            case "YES/6":
                toleranceText = "YES / Resolves 6"; 
                break;
            case "YES/7":
                toleranceText = "YES / Resolves 7";    
                break;
            case "YES/9":
                toleranceText = "YES / Resolves 9";  
                break;
            case "YES/11":
                toleranceText = "YES / Resolves 11";  
                break;
            case "NO/11":
                toleranceText = "NO / Resolves 11";  
                break;
            default:
                toleranceText = "Unknown"; 
        }
        
        return html(toleranceText); 
    },
    },

    {
    id: "wic_no",
    width: "0%",
    name: "wic_no",
    hidden: true,
    },
  ];

  const pagination = {
    enabled: true,
    limit: 50,
  };

  //const sort = {
    //column: "M", // the ID of the column to sort by default
    //direction: "asc", // the sort direction (asc or desc)
  //};

  const fixedHeader = {
    fixedHeader: false,
  };

  const resizable = {
    resizable: true,
  };

  const style = {
    table: {
      border: "1px solid #ccc",
      //'min-width': '1240px'
      //width:'100%'
    },

    th: {
      "background-color": "rgba(0, 0, 0, 0.1)",
      "font-size": "12px",
      overflow: "visible",
      "white-space": " normal",
      color: "#000",
      "border-bottom": "1px solid #ccc",
      "text-align": "center",
    },
    td: {
      "text-align": "center",
      "font-size": "12px",
    },
    centered: {
    "text-align": "center",
    },
  };


  // for the default search box, not used in ths app
  const search = {
    enabled: true,
    selector: (cell, rowIndex, cellIndex) => (cellIndex === 0 ? cell : null),
  };

  const encodeData = (data) => {
    return encodeURI(data).replaceAll("#", "%23").replaceAll("/", "%2F");
  };

  const handleExports = (fileType, currentData) => {
    // console.log(
    //   `hanldeExplorts ${fileType} Data=${data.length} currentData=${currentData.length}`
    // );
    let url = "";
    const fields = [
      "sat_name",
      "adm",
      "ntwk_org",
      "ntc_id",
      "d_rcv",
      "submitted_with",
      "Attachment",
      "Tolerance",
      "wic_no",
    ];

    const fieldMapping = {
    sat_name: "Satellite Name",
    adm: "ADM",
    ntwk_org: "IGSO",
    ntc_id:"RES8 notice ID",
    d_rcv:"Date of receipt",
    submitted_with:"Submitted with",
    Attachment:"Attachment",
    Tolerance:"Tolerance",
  };

  const modifiedData = currentData.map((item) => {
    const modifiedItem = {};
    for (const key in item) {
      if (fieldMapping[key]) {
        modifiedItem[fieldMapping[key]] = item[key];
      } else {
        modifiedItem[key] = item[key];
      }
    }
    return modifiedItem;
  });

    const link = document.createElement("a");
    switch (fileType) {
      case "JSON":
        url =
          encodeURI("data:text/json;charset=utf-8,") +
          encodeData(JSON.stringify(modifiedData, null, 2));
        break;
      case "CSV":
        try {
          const parser = new Parser({
            fields: Object.values(fieldMapping),
            eol: "\r\n",
            header: true,
          });
          let csv = "sep=,\r\n" + parser.parse(modifiedData);
          console.log(csv);
          url = encodeURI("data:text/text;charset=utf-8,") + encodeData(csv);
        } catch (e) {
          alert("Error downloading, please try again");
          console.log("Error downloading, please try again. ", e);
        }
        break;
      case "XLSX":
        break;
      default:
        break;
    }
    link.download = "RES8_Space_Network_List." + fileType.toLowerCase();
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
  };
</script>

<Header />
<main>
  <!-- navigation line-->
  <div>
    <p>
      <em>You are here &nbsp;</em>
      <span><a title="ITU" href="https://www.itu.int/en/about/Pages/default.aspx">ITU</a></span>
      <span> &nbsp&gt&nbsp; </span>
      <span><a href="https://www.itu.int/en/ITU-R/Pages/default.aspx">ITU-R</a></span>
      <span> &nbsp&gt&nbsp; </span>
      <span><a href="https://www.itu.int/en/ITU-R/space/Pages/default.aspx">Space Services</a></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a href="https://www.itu.int/en/ITU-R/space/support/nonGSO/Pages/default.aspx">NGSO</a
        ></span
      >
      <span> &nbsp&gt&nbsp; </span>
      <span
        ><a href="https://www.itu.int/en/ITU-R/space/Pages/res8main.aspx">RES8</a
        ></span
      >
    </p>
  </div>

  <div>
    <p align="left">
      The <a href="https://www.itu.int/en/ITU-R/space/Documents/RES8(WRC-23).pdf"
        >Resolution <b>8 (WRC-23)</b></a
      > defines tolerances for certain orbital characteristics of space stations deployed as part of non-geostationary-satellite systems in the fixed satellite, broadcasting-satellite or mobile-satellite services in certain frequency bands. 
      This webpage displays the list of all satellite systems subject to Resolution <b>8 (WRC-23)</b> and published in the RES8 Special Section of the BRIFIC. Here is the <a href="http://www.itu.int/en/ITU-R/space/Documents/RES8_SpaceNetworkList_Explanations.pdf">explanation</a>. 
    </p>
  </div>

  <div class="FilterBar">
    <div class="TextSearchFilterContainer">
      <div>
        <div class="Icon"><TiFilter /></div>
        <input
          type="text"
          id="sat_name"
          name="sat_name"
          placeholder="Satellite Name"
          bind:value={Sat_name}
          on:input={searchFunction}
        />
      </div>

      <div>
        <div class="Icon"><TiFilter /></div>
        <input type="text" id="adm" name="adm" placeholder="Administration" bind:value={Adm} />
      </div>
    </div>
    <div class="Download">
      <button class="ButtonStyle" on:click={() => handleExports("CSV", displayData)}>
        <div class="Icon"><MdFileDownload /></div>
        Download</button
      >
    </div>
  </div>

  <div id="mytable">
    <!-- //style='width: 2000px;'-->

    <!-- <Grid data={displayData} {columns} {pagination} {language} {fixedHeader} {style} {resizable} /> -->
    <Grid data={displayData} {columns} {pagination} {language} {fixedHeader} {style} {resizable} />
  </div>
  <div>
    <p align="left">Last update of the database: {updateDate}</p>
  </div>
</main>

<Footer />

<style>
  main {
    margin: 0;
    font-family: AvenirNextW06-Medium, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    color: #2f2f2f;
    text-align: left;
    background-color: #f5fafc;
  }
  /* #mytable { */
  /* overflow: auto;*/
  /* } */
  /* links */
  a {
    color: #0076a1;
    text-decoration: none;
    background-color: transparent;
  }
  a:hover {
    color: #0076a1;
    text-decoration: underline;
  }
  a:not([href]):not([class]) {
    color: inherit;
    text-decoration: none;
  }
  a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none;
  }


</style>